
if($('#label').length){
    $("#label").select2({
        placeholder: Lang.get('common.texts.all'),
        allowClear: true
    });
}

if($('#genre').length) {
    $("#genre").select2({
        placeholder: Lang.get('common.texts.genres'),
        minimumInputLength: 0,
        maximumSelectionSize: 3
    });
}

if($('#category').length) {
    $("#category").select2({
        minimumResultsForSearch: Infinity
    });
}

if($('#sort_by').length) {
    $("#sort_by").select2({
        minimumResultsForSearch: Infinity
    });
}

if( ($('#from').length) && ($('#to').length) ) {
    $('#from').datepicker().on('changeDate', function(ev){
        var dateText = $(this).data('date'),
            endDateTextBox = $('#to input');
        if (endDateTextBox.val() != '') {
            var testStartDate = new Date(dateText),
                testEndDate = new Date(endDateTextBox.val());
            if (testStartDate > testEndDate) {
                endDateTextBox.val(dateText);
            }
        } else {
            endDateTextBox.text(dateText);
        };
        $('#to').datepicker('setStartDate', dateText);
        $('#from').datepicker('hide');
    });
    $('#to').datepicker().on('changeDate', function(ev){
        var dateText = $(this).data('date'),
            startDateTextBox = $('#from input');
        if (startDateTextBox.val() != '') {
            var testStartDate = new Date(startDateTextBox.val()),
                testEndDate = new Date(dateText);
            if (testStartDate > testEndDate) {
                startDateTextBox.text(dateText);
            }
        } else {
            startDateTextBox.val(dateText);
        };
        $('#from').datepicker('setEndDate', dateText)
        $('#to').datepicker('hide')
    });
}